import { Component, Input, Output, EventEmitter } from "@angular/core";

export enum ApplyState {
  Unknown,
  Succeeded,
  Failed,
}

@Component({
  selector: "icn-wizard-nav",
  templateUrl: "wizard-nav.component.html",
  styleUrls: ["wizard-nav.component.scss"],
})
export class WizardNavComponent {
  public ApplyEnum = ApplyState;

  @Input()
  backHidden: boolean;

  @Input()
  nextHidden: boolean;

  @Input()
  nextDisabled: boolean;

  @Input()
  applyHidden: boolean;

  @Input()
  applyDisabled: boolean;

  @Input()
  applyState: ApplyState = ApplyState.Unknown;

  @Output()
  back = new EventEmitter<boolean>();

  @Output()
  next = new EventEmitter<boolean>();

  @Output()
  apply = new EventEmitter<boolean>();
}
